import axios from "axios";

export const state = {
  activities: [],
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["id"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  }
};

export const actions = {
  getAllActivities: ({ commit, state }) => {
    const sortingOrder = state.pagination.sortDesc[0] ? "desc" : "asc";
    return axios.get(`activities`, {
      params: {
        per_page: state.pagination.itemsPerPage,
        page: state.pagination.page,
        sort: state.pagination.sortBy[0],
        order: sortingOrder
      }
    })
      .then((resp) => {
        commit("getAllActivitiesSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
};

export const mutations = {
  setActivityPagination: (state, payload) => {
    state.pagination = payload;
  },
  getAllActivitiesSuccess: (state, activities) => {
    state.activities = activities.data;
    state.pagination.totalItems = activities.meta.total;
  }
};

export default {
  state,
  actions,
  mutations
};
